import ApiService from 'api-client/ApiService'

class AppCatalog extends ApiService {
  public getClassName() {
    return 'appcatalog'
  }

  protected async getEndpoint() {
    return this.client.keystone.getServiceEndpoint('appcatalog', 'public')
  }

  // Repository APIs
  async getRepositories() {
    const response = await this.client.basicGet<any>({
      url: `/v1/repo`,
      options: {
        clsName: this.getClassName(),
        mthdName: 'getRepositories',
      },
    })
    return response?.items
  }

  async getRepository(id) {
    const response = await this.client.basicGet<any>({
      url: `/v1/repo/${id}`,
      options: {
        clsName: this.getClassName(),
        mthdName: 'getRepository',
      },
    })
    return response
  }

  async getRepositoryBranch(uid) {
    const response = await this.client.basicGet<any>({
      url: `/v1/repo/${uid}/branch`,
      options: {
        clsName: this.getClassName(),
        mthdName: 'getRepositoryBranch',
      },
    })
    const parsed = typeof response === 'string' ? JSON.parse(response) : response
    return parsed?.branches ?? []
  }

  async createRepository(body: any) {
    const response = await this.client.basicPost<any>({
      url: `/v1/repo`,
      body,
      options: {
        clsName: this.getClassName(),
        mthdName: 'createRepository',
      },
    })
    return response
  }

  async validateSshKey(body: any) {
    const response = await this.client.basicPost<any>({
      url: `/v1/repo/validate`,
      body,
      options: {
        clsName: this.getClassName(),
        mthdName: 'validateSshKey',
      },
    })
    return response
  }

  async deleteRepository(uid) {
    return this.client.basicDelete<any>({
      url: `/v1/repo/${uid}`,
      options: {
        clsName: this.getClassName(),
        mthdName: 'deleteRepository',
      },
    })
  }

  //Templates APIs
  async getTemplates() {
    const response = await this.client.basicGet<any>({
      url: `/v1/template`,
      options: {
        clsName: this.getClassName(),
        mthdName: 'getTemplates',
      },
    })
    return response?.items
  }

  async getTemplate(id) {
    const response = await this.client.basicGet<any>({
      url: `/v1/template/${id}`,
      options: {
        clsName: this.getClassName(),
        mthdName: 'getTemplate',
      },
    })
    return response
  }

  async fetchTerraformModule(body: any) {
    const response = await this.client.basicPost<any>({
      url: `/v1/template/fetchModule`,
      body,
      options: {
        clsName: this.getClassName(),
        mthdName: 'fetchTerraformModule',
      },
    })
    return response
  }

  async createTemplate(body: any) {
    const response = await this.client.basicPost<any>({
      url: `/v1/template`,
      body,
      options: {
        clsName: this.getClassName(),
        mthdName: 'createTemplate',
      },
    })
    return response
  }

  async deleteTemplate(uid) {
    return this.client.basicDelete<any>({
      url: `/v1/template/${uid}`,
      options: {
        clsName: this.getClassName(),
        mthdName: 'deleteTemplate',
      },
    })
  }

  // Application APIs
  async getApplications() {
    const response = await this.client.basicGet<any>({
      url: `/v1/app`,
      options: {
        clsName: this.getClassName(),
        mthdName: 'getApplications',
      },
    })
    return response?.items
  }

  async getApplication(id) {
    const response = await this.client.basicGet<any>({
      url: `/v1/app/${id}`,
      options: {
        clsName: this.getClassName(),
        mthdName: 'getApplication',
      },
    })
    return response
  }

  async getApplicationDetails(id) {
    const response = await this.client.basicGet<any>({
      url: `/v1/app/${id}/output`,
      options: {
        clsName: this.getClassName(),
        mthdName: 'getApplicationDetails',
      },
    })
    return response
  }

  async createApplication(body: any) {
    const response = await this.client.basicPost<any>({
      url: `/v1/app`,
      body,
      options: {
        clsName: this.getClassName(),
        mthdName: 'createApplication',
      },
    })
    return response
  }

  async deleteApplication(uid) {
    return this.client.basicDelete<any>({
      url: `/v1/app/${uid}`,
      options: {
        clsName: this.getClassName(),
        mthdName: 'deleteApplication',
      },
    })
  }
}

export default AppCatalog
